import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

// A questionnaire's questions by how they are answered, in its answer view.
// The options (with counts) come from the questions on the page.
export const QuestionAnswerStatusFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <GenericFilterDropdown
      filterParam={FilterParam.QUESTION_ANSWER_STATUS}
      filterName={FilterName.QUESTION_ANSWER_STATUS}
      valueKey="questionAnswerStatuses"
      isNested={isNested}
    />
  ),
)
